module.exports = __webpack_public_path__ + "static/media/YF96_2.d1cb200e.jpg";